"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MegaphoneFill_exports = {};
__export(MegaphoneFill_exports, {
  default: () => MegaphoneFill_default
});
module.exports = __toCommonJS(MegaphoneFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.09375 14.9766L9.89453 16.8906C9.97266 17.0729 9.97917 17.2552 9.91406 17.4375C9.86198 17.6068 9.7513 17.737 9.58203 17.8281L8.41016 18.4922C8.22786 18.5833 8.03255 18.6029 7.82422 18.5508C7.62891 18.4987 7.47917 18.388 7.375 18.2188L7.35547 18.1602L6.61328 16.3828L9.09375 14.9766ZM10.6953 3.12109C10.7474 3.13411 10.793 3.16016 10.832 3.19922C10.8841 3.23828 10.9232 3.28385 10.9492 3.33594L16.75 13.1602C16.8281 13.3034 16.8411 13.4531 16.7891 13.6094C16.75 13.7526 16.6654 13.8633 16.5352 13.9414C16.4831 13.9674 16.4245 13.987 16.3594 14C16.3073 14.013 16.2552 14.0195 16.2031 14.0195L11.0859 13.6484C10.6302 13.6094 10.1745 13.6419 9.71875 13.7461C9.27604 13.8372 8.85938 14 8.46875 14.2344L5.94922 15.6406C5.76693 15.7448 5.57161 15.7708 5.36328 15.7188C5.16797 15.6667 5.01823 15.5495 4.91406 15.3672L3.09766 12.2812C2.99349 12.112 2.96745 11.9297 3.01953 11.7344C3.07161 11.526 3.1888 11.3698 3.37109 11.2656L5.89062 9.85938L5.98828 9.80078L7.6875 12.6914L7.74609 12.7695C7.83724 12.8867 7.95443 12.9583 8.09766 12.9844C8.25391 13.0104 8.40365 12.9909 8.54688 12.9258C8.67708 12.8477 8.76823 12.737 8.82031 12.5938C8.8724 12.4505 8.86589 12.3073 8.80078 12.1641L8.76172 12.0859L6.96484 9.01953C7.10807 8.85026 7.24479 8.67448 7.375 8.49219C7.50521 8.3099 7.61589 8.12109 7.70703 7.92578L9.93359 3.375C9.9987 3.23177 10.1029 3.13411 10.2461 3.08203C10.4023 3.02995 10.5521 3.04297 10.6953 3.12109ZM16.418 9.80078C16.4701 9.64453 16.5612 9.52734 16.6914 9.44922C16.8216 9.37109 16.9583 9.33854 17.1016 9.35156L17.1797 9.37109L18.3906 9.68359L18.4688 9.70312C18.612 9.76823 18.7161 9.8724 18.7812 10.0156C18.8464 10.1458 18.8529 10.2826 18.8008 10.4258C18.7617 10.569 18.6771 10.6862 18.5469 10.7773C18.4167 10.8555 18.2734 10.8815 18.1172 10.8555L18.0391 10.8359L16.8477 10.543L16.7695 10.5039C16.6263 10.4518 16.5221 10.3607 16.457 10.2305C16.3919 10.0872 16.3789 9.94401 16.418 9.80078ZM17.707 6.16797C17.7982 6.29818 17.8242 6.44141 17.7852 6.59766C17.7591 6.74089 17.681 6.85807 17.5508 6.94922L17.4922 6.98828L15.832 7.92578C15.6758 8.01693 15.513 8.04297 15.3438 8.00391C15.1875 7.95182 15.0638 7.85417 14.9727 7.71094C14.8945 7.58073 14.8685 7.44401 14.8945 7.30078C14.9336 7.14453 15.0117 7.02083 15.1289 6.92969L15.207 6.89062L16.8672 5.93359C17.0234 5.85547 17.1797 5.84245 17.3359 5.89453C17.5052 5.93359 17.6289 6.02474 17.707 6.16797ZM14.4258 2.76953C14.582 2.80859 14.6992 2.89323 14.7773 3.02344C14.8685 3.14062 14.901 3.27734 14.875 3.43359L14.8555 3.51172L14.5234 4.85938C14.4714 5.02865 14.3672 5.15234 14.2109 5.23047C14.0677 5.30859 13.918 5.32812 13.7617 5.28906C13.6055 5.25 13.4818 5.17188 13.3906 5.05469C13.3125 4.92448 13.2865 4.78125 13.3125 4.625V4.54688L13.6641 3.19922C13.7161 3.02995 13.8138 2.90625 13.957 2.82812C14.1003 2.75 14.2565 2.73047 14.4258 2.76953Z",
      fill: "currentColor"
    }
  )
);
const SvgMegaphoneFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MegaphoneFill_default = SvgMegaphoneFill;
